const HeadersText={
    magicVoiceText:{
        en:"Magic Voice",
        fr:"Voix Magique"
    },
    voicesText:
    {
        en:"Voices",
        fr:"Voix"
    },
    ambiencesText:
    {
        en:"Ambiences",
        fr:"Ambiances"
    },
    contactText:
    {
        en:"Contact Page",
        fr:"Page de Contact"
    },
    langText:
    {
        en:"Language Page",
        fr:"Page de Langue"
    },
    accountText:
    {
        en:"My Account",
        fr:"Mon Compte"
    }
}
const DialerText={
    minLengthText:
    {
        en:"The number should be atleast 5 digits long",
        fr:"Le numéro doit comporter au moins 5 chiffres"
    },
    maxLengthText:
    {
        en:"The number should not exceed 15 digits ",
        fr:"Le numéro ne doit pas dépasser 15 chiffres"
    },
    noNumText:
    {
        en:"Please dial the number",
        fr:"Veuillez composer le numéro"
    }
};
const ContactsText={
    notFoundText:
    {
        en:"No contacts were found.Try using another google account.",
        fr:"Aucun contact trouvé. Veuillez utiliser un autre compte Google."
    },
    allowText:
    {
        en:"Allow accessing your contacts.",
        fr:"Autoriser l'accès à vos contacts."
    },
    wentWrongText:
    {
        en:"Something went wrong,please try again later.",
        fr:"Quelque chose s'est mal passé, veuillez réessayer plus tard."
    },
    fetchingText:
    {
        en:"Fetching",
        fr:"Récupération"
    },
    loadText:
    {
        en:"Load More",
        fr:"Charger Plus"
    },
    noCallMadeText:
    {
        en:"Can not make the call ,since no number is there",
        fr:"Impossible de passer l'appel, car aucun numéro n'est disponible."
    }
}
const RecentText={
    noCallsText:
    {
        en:"No calls yet!",
        fr:"Aucun appel pour l'instant!"
    }
}
const accountPageText={
   unsubBtnText:
   {
    en:"Unsubscribe",
    fr:"Se Désabonner"
   },
   subscribeText:
   {
    en:"Subscribe",
    fr:"S'Abonner"
   },
   numText:
   {
    en:"Mobile Number",
    fr:"Numéro de Mobile"
   },
   validityText:
   {
    en:"Validity",
    fr:"Validité"
   },
   userStatusText:
   {
    en:"User Status",
    fr:"Statut de l'Utilisateur"
   },
   confirmationText:
   {
    en:"Are you sure you want to unsubscribe?",
    fr:"Êtes-vous sûr de vouloir vous désabonner?"
   },
   yesBtnText:
   {
    en:"Yes",
    fr:"Oui"
   },
   noBtnText:
   {
    en:"No",
    fr:"Non"
   },
   okBtnText:{
    en:"Okay",
    fr:"D'accord"
}
};
const notAuthorized={
    en:"You are not authorized to access this page.",
    fr:"Vous n'êtes pas autorisé à accéder à cette page."
}
export  {HeadersText,DialerText,ContactsText,RecentText,accountPageText,notAuthorized};